var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "reviews__slide-box" }, [
    _c("div", { staticClass: "slide-box" }, [
      _c("div", { staticClass: "slide-box__name" }, [
        _c("p", { staticClass: "name" }, [_vm._v(_vm._s(_vm.title))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "slide-box__picture" }, [
        _c("img", {
          staticClass: "picture lazy",
          attrs: {
            "data-src": _vm.image,
            alt: _vm.title,
            src: "static/img/general/logo-header.png",
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "slide-box__paragraph",
        domProps: { innerHTML: _vm._s(_vm.content) },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }